export enum enumSaleItemType {
  Product = 1, Course = 2, Session = 3, Voucher=4, Appointment = 5, 
  MaxSaleItem = 79,
  CashTendered = 80, VoucherTendered=85, CardTendered = 90, CreditsTendered = 100,
  InvoiceMax = 999,
  SaleValue = 1010,
  TotalToPay = 1020,
  TotalTendered = 1030,
  OutstandingBalance = 1040,
  Change = 1050,
};

export enum enumProductClass {
  None = 0,
  Product = 1,
  Session = 2,
  Course = 3,
  TimeElapsedCourse = 4,
  Voucher = 5,
  Membership = 6,
}

export class CreditCalcInfo {
  ClientName:string="CLient Name";
  ClientCredits:string  = "5 Tanning Credits";
  SessionName:string = "15 Min HBed";
  SessionCost:string  = "£13.99";
  SessionCredits:string  ="15";
  CreditsRequired: string = "10";
  ExtraCost : number = 10.0;
}

export class SaleItem {
  SaleItemId: number = 0;
  ProductId: number = 0;
  ResourceId: number = 0;
  Description: string = "";
  Price: number = 0.0;
  FullPrice: number = 0.0;
  StaffUpdatedPrice: boolean = false;
  CreditsCalculated: boolean = false;
  Qty: number = 1;
  Tendered: boolean = false;
  CreditsUsed: number = 0.0;
  Unlimited: boolean = false;
  SaleItemType: number; // 1=Product, 2=course, 3=session, 40 = total,  80=Cash, 90=card
  DisclaimerRequired: boolean = false;
  DisclaimerAccepted: boolean = false;
  DisclaimerCode: string = "";
  DiscountCode:number;  
  DisclaimerAcceptanceType: number = -1;
  ShowEditor:number=0;
  EditorData:CreditCalcInfo;
  Discount:number;
  IsVoucher:boolean=false;
  VoucherCode:string="";
  CashValue:number=0.0;
  DepositPaid: number = 0.0;

  public static CreateFrom(a: SaleItem): SaleItem {
    var r = new SaleItem();
    if (a) {
      r.Price = a.Price;
      r.ProductId = a.ProductId;
      r.Description = a.Description;
      r.Qty = a.Qty;
      r.SaleItemType = a.SaleItemType;
      r.Tendered = a.Tendered;
      r.Unlimited = r.Unlimited;
      r.SaleItemId = a.SaleItemId;
      r.DisclaimerAccepted = a.DisclaimerAccepted;
      r.DisclaimerRequired = a.DisclaimerRequired;
      r.DisclaimerCode = a.DisclaimerCode;      
      r.DisclaimerAcceptanceType = a.DisclaimerAcceptanceType;
      r.StaffUpdatedPrice = a.StaffUpdatedPrice;
      r.FullPrice = a.FullPrice;
      r.ShowEditor=a.ShowEditor;
      r.EditorData=a.EditorData;
      r.Discount=a.Discount;
      r.DiscountCode=a.DiscountCode;
      r.IsVoucher=a.IsVoucher;
      r.VoucherCode=a.VoucherCode;
      r.CashValue=a.CashValue;
      r.DepositPaid = a.DepositPaid;
    }
    return r;
  }

  public static Create(SaleItemType: enumSaleItemType, Description: string): SaleItem {
    var si = new SaleItem();
    si.SaleItemType = SaleItemType;
    si.Description = Description;
    si.StaffUpdatedPrice = false;
    si.Price = 0.0;
    si.CashValue=0.0;
    si.IsVoucher=false;
    si.VoucherCode="";
    si.DiscountCode=-1;
    si.Discount=0.0;    
    si.Qty = 1;    

    if (SaleItemType >= enumSaleItemType.CashTendered)
      si.SaleItemId = SaleItemType;
    return si;
  }

  public get TypeDesc(): string {
    switch (this.SaleItemType) {
      case enumSaleItemType.Product: return "Product";
      case enumSaleItemType.Course: return "Course";
      case enumSaleItemType.Session: return "Session";
      case enumSaleItemType.Voucher: return "Voucher";
      case enumSaleItemType.CashTendered: return "Cash";
      case enumSaleItemType.CardTendered: return "Card";
      case enumSaleItemType.SaleValue: return "Sale Value";
      case enumSaleItemType.TotalTendered: return "Total Tendered";
      case enumSaleItemType.TotalToPay: return "Total To Pay";
      case enumSaleItemType.OutstandingBalance: return "Outstanding Balance";
      case enumSaleItemType.Change: return "Change";
      default: return "Unknown";
    }
  }
}